import { SOCIAL_CONFIG } from '../brands/default/config';

const CLIENT_ID =
  SOCIAL_CONFIG.GOOGLE.GOOGLE_ID[process.env.NEXT_PUBLIC_ENVIRONMENT || 'dev'][
    process.env.NEXT_PUBLIC_SITE || 'wowcher'
  ];

export const loadGoogleScript = (callback) => {
  const existingScript = document.querySelector('#googleAPI');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.id = 'googleAPI';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};

export const gapiInit = (handler) => {
  // eslint-disable-next-line no-undef
  google.accounts.id.initialize({
    callback: handler,
    client_id: CLIENT_ID,
    cookiepolicy: 'single_host_origin',
  });
};

export const logoutGoogle = async (auth2) => {
  await auth2?.signOut();
  auth2?.disconnect();
};
